import { Flex, Typography, Skeleton } from 'antd';
import {
  type TStatuses,
  type Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import ReadingsList from 'components/organisms/oneplatform/patient-readings/readings-list';
import { format } from 'date-fns';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { FC } from 'react';

const { Text } = Typography;
interface LatestReadingProps {
  id?: string;
  values?: Value;
  statuses?: TStatuses;
  createdAt?: string;
  isLoading?: boolean;
  isDisplayTimestampVertically?: boolean;
}

const LatestReading: FC<LatestReadingProps> = ({
  id,
  values,
  statuses,
  createdAt,
  isLoading = false,
  isDisplayTimestampVertically,
}) => {
  if (isLoading) {
    return (
      <Flex className={s.wrapper} align="center">
        {isDisplayTimestampVertically ? (
          <Flex vertical gap={0}>
            <Skeleton.Input
              active
              size="small"
              className={s['skeleton-reading']}
            />
            <Skeleton.Input
              active
              size="small"
              className={s['skeleton-date']}
            />
          </Flex>
        ) : (
          <Flex vertical gap={0}>
            <Flex gap={6}>
              <Skeleton.Input
                active
                size="small"
                className={s['skeleton-reading']}
              />
              <Skeleton.Input
                active
                size="small"
                className={s['skeleton-reading']}
              />
            </Flex>
            <Skeleton.Input
              active
              size="small"
              className={s['skeleton-date']}
            />
          </Flex>
        )}
      </Flex>
    );
  }

  if (!id || !values || !statuses) {
    return null;
  }

  return (
    <Flex className={s.wrapper} align="center">
      <Flex
        vertical={isDisplayTimestampVertically}
        gap={isDisplayTimestampVertically ? 0 : 8}
      >
        <ReadingsList
          id={id}
          values={values}
          statuses={statuses}
          fontWeight={400}
          justify="start"
          timestampText={
            !isDisplayTimestampVertically
              ? `(${
                  createdAt
                    ? format(
                        new Date(createdAt),
                        DateFormats['MM/dd/yyyy hh:mm:ss a'],
                      )
                    : ''
                })`
              : ''
          }
        />
        {isDisplayTimestampVertically && (
          <Text className={s.date}>
            (
            {createdAt
              ? format(
                  new Date(createdAt),
                  DateFormats['MM/dd/yyyy hh:mm:ss a'],
                )
              : ''}
            )
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
export default LatestReading;
